// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddVendorMutation($input: AddVendorInput!) {
    addVendor(input: $input) {
      vendorEdge {
        node {
          id
          vendorNumber
          name
          email
          phone
          address
          city
          state
          zipCode
          country
          paymentTerms
          rating
          createdAt
          updatedAt
          itemPrices {
            edges {
              node {
                id
                item {
                  id
                  name
                }
                unitPrice
                leadTimeDays
                isPreferred
              }
            }
          }
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_ADD',
          parentID: ROOT_ID,
          connectionInfo: [
            {
              key: 'VendorList_vendors',
              rangeBehavior: 'prepend',
            },
          ],
          edgeName: 'vendorEdge',
        },
      ],
    });
  },
};
